/**
 * Tool-ownership policy between the shared CAD ToolScope (react hook
 * scopes) and the BIM class controller (useToolController) — B4
 * cross-workbench edit bridge.
 *
 * Both pipelines react to `useAppStore.activeTool` (single source of
 * truth). In the BIM viewport only ONE of them may own a tool id, or the
 * same pointer gesture double-applies (e.g. a wall moved once by the
 * joint-aware BIM class and again by the CAD data-bag path).
 *
 * - BIM_OWNED_TOOL_IDS: ids BIM's class controller keeps owning even where
 *   ToolScope is mounted (BimViewport passes this as ToolScope's exclude).
 * - CAD_SCOPE_TOOL_IDS: ids ONLY the CAD ToolScope implements — the BIM
 *   class registry has no citizen for them, so its controller drops to an
 *   idle tool instead of select-clicking through the CAD gesture.
 */

/** Ids BIM's class controller owns (ToolScope excludes them on request). */
export const BIM_OWNED_TOOL_IDS: ReadonlySet<string> = new Set([
    // modify tools owned by BIM's class controller (src/tools/modify)
    'MOVE', 'move', 'COPY', 'copy', 'ROTATE', 'rotate', 'SCALE', 'scale',
    'OFFSET', 'offset', 'MIRROR_PICK',
    // BIM category placement tools owned by BIM's class controller
    'wall', 'door', 'window', 'floor', 'roof', 'ceiling', 'stair',
    'railing', 'ramp', 'component', 'area', 'column', 'toposolid',
]);

/** Ids only the shared CAD ToolScope implements (both spellings included;
 *  callers match either the raw activeToolId or its uppercased form). */
export const CAD_SCOPE_TOOL_IDS: ReadonlySet<string> = new Set([
    'line', 'LINE', 'circle', 'CIRCLE', 'rectangle', 'RECTANGLE',
    'arc', 'ARC', 'polygon', 'POLYGON', 'polyline', 'POLYLINE',
    'ellipse', 'ELLIPSE', 'text', 'TEXT', 'mtext', 'MTEXT',
    'dimLinear', 'DIMLINEAR', 'dimAligned', 'DIMALIGNED',
    'dimRadius', 'DIMRADIUS', 'dimDiameter', 'DIMDIAMETER',
    'curve', 'CURVE', 'box', 'BOX', 'revolve', 'REVOLVE',
    'point', 'POINT', 'points', 'POINTS', 'mirror', 'MIRROR',
]);
